import moment from 'moment';
export default {
    install(app) {
        app.config.globalProperties.$helper = {

            sayHello(name = "User") {
                console.log(`Hello, ${name}!`);
            },

            isLoggedIn() {
                return !!localStorage.getItem("user");
            },

            formatDate(dateStr) {
                const d = new Date(dateStr);
                return d.toLocaleDateString();
            },

            getFormattedAmount_(sub) {
                var formatter = new Intl.NumberFormat("en-US");
                return formatter.format(sub).replace(".00", "");
            },

            formatAmountMode(value, mode) {
            value = !value ? 0 : value
            let amount = Math.floor(Math.abs(value)); // Whole number part
            let decimal = (value % 1).toFixed(2).split('.')[1]; // Decimal part
            return mode === 1 ? this.getFormattedAmount_(Math.abs(amount)) : decimal;
            },

            formatAmount(amount) {
                var formatter = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                var val = formatter.format(amount);
                return amount < 0 ? `(${val.replace("-", "")})` : val
            },

            formatDateTime(timestamp) {
                return moment.unix(timestamp).format('MM/DD/YYYY hh:mm A');
            },

            formattedDate(timestamp) {
                return moment.unix(timestamp).format('MM/DD/YYYY');
            },

            formatDateTimestamp(timestamp, format) {
                return moment.unix(timestamp).format(format);
            },

            isEmpty(value) {
                return (
                    value === null ||
                    value === undefined ||
                    (typeof value === "string" && value.trim() === "") ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === "object" && Object.keys(value).length === 0)
                );
            },
            formatPhoneNumber(phone) {
                if (!phone || typeof phone !== 'string') return '-';

                // Match phone number in the format +1XXXXXXXXXX
                const match = phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
                if (!match) return phone; // If it doesn't match +1XXXXXXXXXX, return as-is

                const [, area, prefix, line] = match;
                return `(${area}) ${prefix}-${line}`;
            },

            getTimeAgo(date) {
                const createdTime = new Date(date);
                const currentTime = new Date();
                const diffInSeconds = Math.floor((currentTime - createdTime) / 1000);

                const minutes = Math.floor(diffInSeconds / 60);
                const hours = Math.floor(minutes / 60);
                const days = Math.floor(hours / 24);
                const weeks = Math.floor(days / 7);
                const months = Math.floor(days / 30);
                const years = Math.floor(days / 365);

                if (years > 0) return `${years} ${(years > 1 ? `Years` : `Year`)} ago`;
                if (months > 0) return `${months} ${(months > 1 ? `Months` : `Month`)} ago`;
                if (weeks > 0) return `${weeks} ${(weeks > 1 ? `Weeks` : `Week`)} ago`;
                if (days > 0) return `${days}d ago`;
                if (hours > 0) return `${hours}h ago`;
                if (minutes > 0) return `${minutes}m ago`;

                return `just now`;
            },

            generateScheduleMessage(items) {
                const labels = {
                    sar: "SAR",
                    uq: "UQ",
                    mq: "MQ",
                    rq: "RQ",
                    appt: "Appointments",
                };

                // label → count (order preserved)
                const result = {};

                for (const item of items) {
                    const type = item.job_type || item.jobType; // API / backend safe

                    if (!type || !labels[type]) continue;

                    const label = labels[type];
                    result[label] = (result[label] || 0) + 1;
                }

                const entries = Object.entries(result);
                if (!entries.length) return null;

                let message = "You already have ";

                entries.forEach(([label, count], index) => {
                    if (index > 0) message += ", ";
                    message += `${String(count).padStart(2, "0")} ${label}`;
                });

                message += " scheduled at this time.\nDo you want to continue anyway?";

                return message;
            },

            formattedPercentage(percent){
                let num = percent ?? 0;
                return `${parseFloat(num).toFixed(2)}%` ;
            },

            // "see https://x.y/z." → [{ text: "see " }, { text: "https://x.y/z", url }, { text: "." }] so chat / SMS can render
            // links as <a> without v-html (consumers write these messages); trailing punctuation stays text
            linkParts(text) {
                const str = String(text ?? "");
                const parts = [];
                let last = 0;
                for (const m of str.matchAll(/(?:https?:\/\/|www\.)[^\s<]+/gi)) {
                    const link = m[0].replace(/[.,;:!?)\]]+$/, "");
                    if (m.index > last) parts.push({ text: str.slice(last, m.index) });
                    parts.push({ text: link, url: /^https?:/i.test(link) ? link : "https://" + link });
                    last = m.index + link.length;
                }
                if (last < str.length) parts.push({ text: str.slice(last) });
                return parts;
            },

            // status_text as the lists show it: "PAYMENT PENDING" → "Payment Pending"
            formatStatus(status) {
                return status?.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
            },

            // Service & Repair status pill colour (status_text: "EN ROUTE", "EVALUATION STARTED" …), used by the S&R list,
            // its cards and the Job History modal; unknown → grey
            sarStatusColor(status) {
                const colors = {
                    'EN ROUTE': '#65B741',
                    'PENDING': '#F39C12',
                    'CANCELLED': '#D7385E',
                    'NO SALE': '#CA6180',
                    'NEW SYSTEM': '#1D5D9B',
                    'PAYMENT PENDING': '#F59E0B',
                    'ARRIVED': '#635985',
                    'CONVERTED TO BOOKING': '#635985',
                    'CLOSED': '#686D76',
                    'COMPLETED': '#65B741',
                    'EVALUATION STARTED': '#5E366A',
                    'STARTED': '#03AED2',
                    'SUSPENDED': '#B91C1C',
                    'EVALUATION COMPLETED': '#65B741',
                    'ACCEPTED': '#7695FF',
                    'CONSUMER QUOTE DECLINE': '#D7385E',
                };
                return colors[String(status ?? '').trim().toUpperCase()] || '#6B7280';
            },

            isProxyLoggedIn() {
                let user = JSON.parse(localStorage.getItem('user'))
                if (user && user?.proxied_by) {
                    return true
                } else {
                    return false
                }
            },
        };

        app.config.globalProperties.$constants = constants
    }
}

// also export plain constants for non-Vue files
export const constants = {
  EMAIL_REGEX: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\];'`~+=_-])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\];'`~+=_-]{8,}$/,
  ZIP_CODE_REGEX: /^\d{5}$/,
  APPOINTMENT_TITLE: 'Appointment',
  UQ_TITLE: 'Universal Quote',
  SAR_TITLE: 'Service & Repair',
  CHECKOUT_TITLE: "Checkout"
}